import axiosClient from "./axiosClient";
import { apiPath } from '../../utils/api-contants';

const notification = {
    fetchNotifications: async (token: string) => {
      try {
        // const res = [
        //   { id: 5,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "21/06/2023 3:30PM",type:"error"},
        //   { id: 6,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "22/04/2023 4:30PM",type:"error"},
        //   { id: 7,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "23/03/2023 2:30PM",type:"success"},
        //   { id: 8,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "24/02/2023 3:30PM",type:"text"},
        //   { id: 9,title:"message", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "25/01/2023 4:30PM",type:"warning"},
        //   { id: 1,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "12/09/2023 12:45PM",type:"success"},
        //   { id: 2,title:"Lorem Ipsum ", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "12/09/2023 3:30PM",type:"warning"},
        //   { id: 3,title:"project", message: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.", date: "10/09/2023 4:30PM",type:"success"},
        //   { id: 4,title:"Iot", message: "Lorem Ipsum is simply printing and typesetting industry in bangalore.", date: "20/07/2023 2:30PM",type:"info"},
        // ];
        // REACT_APP_BASE_URL
        
        const apiResponse: any = await axiosClient.get(apiPath.BASE_URL_API+'notifications');
        const res: any = apiResponse.data;
        return {
          status: 'success',
          res,
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    },
    removeNotification: async (payload: object) => {
      // const url = `/check_token/${token}`;
      // console.log(payload, 'PAYLOAD');
      try {
        // const res = await axiosClient.get(url);
        // const data: any = { id: 1, key: 'Hot', displayName: 'Shiva', port: 35, types: 'TCP' };
        return {
          status: 'success',
          data: payload,
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    },
    removeAllNotifications: async () => {
      // const url = `/check_token/${token}`;
      // console.log(payload, 'PAYLOAD');
      try {
        // const res = await axiosClient.get(url);
        // const data: any = { id: 1, key: 'Hot', displayName: 'Shiva', port: 35, types: 'TCP' };
        return {
          status: 'success',
        };
      } catch (error) {
        return {
          status: 'error',
          error,
        };
      }
    },
}

export default notification;